import Common from "../../../Common";
import Profile from "./profile/Profile";

interface Body {
	name?: string
	description?: string
	default_pbx_profile_id?: id
}

interface ApplyBody {
	pbx_user_id: id
	reset?: boolean
}

export interface Read {
	id: id
	name: string
	description: string
	nguc_partner_id?: id
	nguc_reseller_id?: id
	pbx_company_id?: id
	update_allowed?: 0 | 1
}

const Profiles = class extends Common {
	profile: InstanceType<typeof Profile>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.profile = new Profile(headers);
	}

	browse = (companyId: id) =>
		this.get(`/company/${companyId}/templates/profiles`)

	read = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/templates/profiles/${id}`)

	access = (companyId: id, templateId: id) =>
		this.get(`/company/${companyId}/templates/profiles/access/${templateId}`)

	clone = (companyId: id, id: id, body: TemplateCloneBody = {}) =>
		this.post(`/company/${companyId}/templates/profiles/${id}/clone`, body)

	update = (companyId: id, id: id, body: Body) =>
		this.patch(`/company/${companyId}/templates/profiles/${id}`, body)

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/templates/profiles/${id}`)

	apply = (companyId: id, id: id, body: ApplyBody) =>
		this.post(`/company/${companyId}/templates/profiles/${id}/apply`, body)
}

export default Profiles
